import { Options, Vue, Watch } from 'vue-property-decorator';
import FullCalendar, { Calendar, CalendarOptions, EventInput } from '@fullcalendar/vue3';
import '@fullcalendar/core/vdom';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import moment from 'moment';

@Options({
  props: {
    eventData: Array,
    viewSelector: Boolean,
    todayButton: Boolean,
    defaultView: String,
    header: String,
    isPortalOffline: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FullCalendar,
  },
})
export default class CalendarView extends Vue {
  eventData?: EventInput[];
  viewSelector!: boolean;
  todayButton!: boolean;
  defaultView!: string;
  header?: string;
  isPortalOffline!: boolean;

  private calendarOptions: CalendarOptions = null as any;

  private calendarApi: Calendar | undefined;
  // private currentDate = moment(new Date);
  private currentDateDisplay = moment(new Date()).format('MMMM YYYY');
  private calendarView = '3';

  @Watch('eventData')
  private onEventDataChanged(): void {
    this.calendarApi?.removeAllEventSources();
    this.calendarApi?.addEventSource({ events: this.eventData });
    this.$nextTick(() => {
      this.calendarApi?.refetchEvents();
    });
  }

  created(): void {
    this.calendarOptions = {
      plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
      initialView: 'dayGridMonth',
      headerToolbar: false,
      // headerToolbar: {
      // left: 'prev,next today',
      // center: 'title',
      // right: 'dayGridMonth,timeGridWeek,timeGridDay'
      // },
      eventTimeFormat: {
        hour: 'numeric',
        minute: '2-digit',
        meridiem: 'narrow',
      },
      dayHeaderFormat: function (d) {
        return moment(d.date).format('ddd');
      },
      firstDay: 1,
      // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
      editable: false,
      selectable: true,
      selectMirror: true,
      dayMaxEvents: true,
      displayEventTime: false,
      weekends: true,
      // select: this.handleDateSelect,
      eventClick: this.handleEventClick,
      // eventsSet: this.handleEvents
      /* you can update a remote database when these fire:
      eventAdd:
      eventChange:
      eventRemove:
      */
    };
    this.$nextTick(() => {
      this.calendarApi = (this.$refs.fullCalendar as InstanceType<typeof FullCalendar>).getApi();
      this.$emit('uiDateTimeRangeChanged', this.calendarApi?.view);
    });
  }

  private handleEventClick(info: any): void {
    info.jsEvent.preventDefault();
    this.$emit('eventItemClicked', info);
  }

  private prev() {
    if (this.calendarApi) this.calendarApi.prev();
    this.updateDisplay();
  }

  private next() {
    if (this.calendarApi) this.calendarApi.next();
    this.updateDisplay();
  }

  private today() {
    if (this.calendarApi) this.calendarApi.today();
    this.updateDisplay();
  }

  @Watch('calendarView')
  onCalendarViewChanged(): void {
    this.updateDisplay();
  }

  private updateDisplay() {
    const _from_date = moment(this.calendarApi?.getDate()).startOf('week');
    const _to_date = moment(this.calendarApi?.getDate()).endOf('week');
    switch (this.calendarView) {
      case '1':
        this.calendarApi?.changeView('timeGridDay');
        this.calendarApi?.setOption('dayHeaderFormat', (d) => moment(d.date).format('dddd DD/MM'));
        this.currentDateDisplay = moment(this.calendarApi?.getDate()).format('DD MMM YYYY');
        break;
      case '2':
        this.calendarApi?.changeView('timeGridWeek');
        this.calendarApi?.setOption('dayHeaderFormat', (d) => moment(d.date).format('ddd DD/MM'));
        this.currentDateDisplay = _from_date.format('DD MMM') + ' - ' + _to_date.format('DD MMM YYYY');
        break;
      case '3':
        this.calendarApi?.changeView('dayGridMonth');
        this.calendarApi?.setOption('dayHeaderFormat', (d) => moment(d.date).format('ddd'));
        this.currentDateDisplay = moment(this.calendarApi?.getDate()).format('MMMM YYYY');
        break;
    }

    this.$emit('uiDateTimeRangeChanged', this.calendarApi?.view);
  }
}
